import { jsx as _jsx } from "react/jsx-runtime";
import classNames from "classnames";
export function Button({ children, className, variant = "primary", as, ...rest }) {
    const Component = as ?? "button";
    return (_jsx(Component, { className: classNames("cvr-button", className, {
            "cvr-button--primary": variant?.startsWith("primary"),
            "cvr-button--secondary": variant?.startsWith("secondary"),
            "cvr-button--tertiary": variant?.startsWith("tertiary"),
            "cvr-button--icon": variant?.startsWith("icon"),
            "cvr-button--large": variant?.endsWith("large"),
            "cvr-button--medium": variant?.endsWith("medium"),
            "cvr-button--small": variant?.endsWith("small"),
            "cvr-button--compact": variant?.endsWith("compact"),
        }), ...rest, children: children }));
}
